const riot = require('riot');

riot.tag2('page-projects', '<div class="s-full f"> <div data-is="module-sidebar"></div> <div class="s-full f fclm bg-gray_light_10 p40"></div> </div>', 'page-projects,[data-is="page-projects"]{display:block}', '', function(opts) {
    this.preload = async ({req, res}) => {
      if (!spat.isBrowser) return ;

      if (!app.auth.isSignIn()) {
        res.redirect(301, '/signin');
        return ;
      }
      var company_id = req.params.company_id;

      var item = app.utils.getLastSeenItem();
      var project_id = item[company_id] ? item[company_id] : null;
      if (project_id) {
        try {
          var { project } = await app.api.child(`companies/${company_id}/projects/${project_id}`).get({});
          res.redirect(301, `/app/companies/${company_id}/projects/${project.id}`);
          return;
        }
        catch (e) {

        }
      }
      var { projects } = await app.api.child(`me/companies/${company_id}/projects`).get({ limit: 1, offset: 0 });

      if (projects && projects.length) {
        var project = projects[0];
        res.redirect(301, `/app/companies/${company_id}/projects/${project.id}`);
      }

      else {
        res.redirect(301, `/app/companies/${company_id}/projects/new`);
      }
      return;
    };
});